import { SortDirection } from '@material-ui/core';
import { RedemptionReportFilters } from 'features/redemptions/ts/RedemptionReportFilters';

export const orderByToOrdering = (orderBy: SortDirection): RedemptionReportFilters['ordering'] => {
  switch (orderBy) {
    case 'asc':
      return 'created_at';
    case 'desc':
    default:
      return '-created_at';
  }
};

export const orderingToSortDirection = (ordering: RedemptionReportFilters['ordering']): SortDirection => {
  switch (ordering) {
    case '-created_at':
      return 'desc';
    case 'created_at':
      return 'asc';
    default:
      return false;
  }
};
